import React from 'react';
import { Routes, Route } from 'react-router-dom';
import EmailInput from '../components/Pages/LoginWithEmail/EmailInput'
import CustomPage from '../components/Pages/customPages/CustomPage.js'
import SyllabusPage from '../components/pre-defined-pages/Syllabus.js';
import Section from '../components/pre-defined-pages/section.js';
import FacultyOfficeHours from '../components/pre-defined-pages/FacultyOfficeHours.js';
import FacultyStaff from '../components/pre-defined-pages/FacultyAndStaff.js';
import Home from '../components/pre-defined-pages/Home.js';
import Course from '../components/pre-defined-pages/Course.js';
import FacultyClassSchedule from '../components/pre-defined-pages/FacultyClassSchedule.js';
import DegreeAndCertificate from '../components/pre-defined-pages/DegreeAndCertificate.js';
import FinalExamSchedule from '../components/pre-defined-pages/FinalExamSchedule.js';
import UniversityHome from '../components/pre-defined-pages/UniversityHome.js';
import DivisionHome from '../components/pre-defined-pages/DivisionHome.js';

const AppRoutes = () => {
  return (
    <Routes>
      {/* University Root level route */}
      <Route path="/" element={<UniversityHome />} />
      <Route path="/Division" element={<UniversityHome />} />
      <Route path="/page/:pageName" element={<CustomPage />} />

      {/* Division level routes */}
      <Route path="/Division/:division" element={<DivisionHome />} />
      <Route path="/Division/:division/Departments" element={<DivisionHome />} />
      <Route path="/Division/:division/page/:pageName" element={<CustomPage />} />

      {/* Department level routes */}
      <Route path="/Division/:division/Department/:department" element={<Home />} />
      <Route path="/Division/:division/Department/:department/Course" element={<Course />} />
      <Route path="/Division/:division/Department/:department/syllabus" element={<SyllabusPage />} />
      <Route path="/Division/:division/Department/:department/section" element={<Section />} />
      <Route path="/Division/:division/Department/:department/FacultyOfficeHours" element={<FacultyOfficeHours />} />
      <Route path="/Division/:division/Department/:department/FacultyClassSchedule" element={<FacultyClassSchedule />} />
      <Route path="/Division/:division/Department/:department/FacultyAndStaff" element={<FacultyStaff />} />
      <Route path="/Division/:division/Department/:department/DegreeAndCertificate" element={<DegreeAndCertificate />} />
      <Route path="/Division/:division/Department/:department/FinalExamSchedule" element={<FinalExamSchedule />} />
      <Route path="/Division/:division/Department/:department/page/:pageName" element={<CustomPage />} />

      
    </Routes>
  );
};

export default AppRoutes;
